import { Volume1, Volume2, VolumeX } from "lucide-react";
import { useState, useEffect } from "react";
import { useAudioPlayerContext } from "../../../context/audioPlayerContext";

export const VolumeControl = () => {
  const [volume, setVolume] = useState(50);
  const [muteVolume, setMuteVolume] = useState(false);

  const handleVolumeChange = (e) => {
    setVolume(Number(e.target.value));
  };

  const { audioRef } = useAudioPlayerContext();

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume / 100;
      audioRef.current.muted = muteVolume;
    }
  }, [volume, audioRef, muteVolume]);

  return (
    <>
      <div className="flex items-center gap-3">
        <button onClick={() => setMuteVolume((prev) => !prev)}>
          {muteVolume || volume < 5 ? (
            <VolumeX />
          ) : volume < 40 ? (
            <Volume1 />
          ) : (
            <Volume2 />
          )}
        </button>
        <input
          type="range"
          min={0}
          max={100}
          value={volume}
          className="volumn"
          onChange={handleVolumeChange}
        />
      </div>
    </>
  );
};
